import { Star } from "lucide-react";

export default function Marquee({ items, dark = true }) {
  const row = [...items, ...items, ...items];
  return (
    <div
      className={`pause-on-hover overflow-hidden border-y py-4 ${
        dark ? "border-white/10 bg-brand-navy" : "border-brand-border bg-white"
      }`}
      data-testid="marquee-band"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span
              className={`font-heading text-sm font-bold uppercase tracking-[0.3em] ${
                dark ? "text-white/85" : "text-brand-blue"
              }`}
            >
              {item}
            </span>
            <Star className="h-3.5 w-3.5 fill-brand-orange text-brand-orange" />
          </span>
        ))}
      </div>
    </div>
  );
}
